'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const CalendarIntegration = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [savedStatus, setSavedStatus] = useState<string | null>(null);

  const eventData = {
    title: 'Moyak & Gloria Wedding Ceremony',
    description: 'Join us in celebrating the sacred union of Moyak and Gloria',
    location: 'Grace Community Church, 456 Faith Avenue, Springfield, IL 62701',
    startDate: '2026-11-20T15:00:00',
    endDate: '2026-11-20T16:30:00',
  };

  const handleGoogleCalendar = () => {
    const startDate = eventData?.startDate?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    const endDate = eventData?.endDate?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(eventData?.title)}&dates=${startDate}/${endDate}&details=${encodeURIComponent(eventData?.description)}&location=${encodeURIComponent(eventData?.location)}`;
    window.open(url, '_blank');
  };

  const handleAppleCalendar = () => {
    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${eventData?.startDate?.replace(/[-:]/g, '')?.split('.')?.[0]}Z
DTEND:${eventData?.endDate?.replace(/[-:]/g, '')?.split('.')?.[0]}Z
SUMMARY:${eventData?.title}
DESCRIPTION:${eventData?.description}
LOCATION:${eventData?.location}
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'moyak-gloria-wedding.ics';
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleOutlookCalendar = () => {
    const startDate = eventData?.startDate?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    const endDate = eventData?.endDate?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    const url = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(eventData?.title)}&startdt=${startDate}&enddt=${endDate}&body=${encodeURIComponent(eventData?.description)}&location=${encodeURIComponent(eventData?.location)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="bg-card rounded-lg shadow-sacred-md p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="CalendarDaysIcon" size={28} className="text-primary" />
        <h3 className="font-playfair text-2xl font-semibold text-foreground">Save the Date</h3>
      </div>

      <p className="font-inter text-sm text-muted-foreground mb-6">
        Add our wedding to your calendar so you don't miss this special day!
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <button
          onClick={handleGoogleCalendar}
          className="flex items-center justify-center space-x-2 px-4 py-3 bg-primary text-primary-foreground rounded-md font-inter text-sm font-medium hover:bg-primary/90 transition-colors duration-200"
        >
          <Icon name="CalendarIcon" size={18} />
          <span>Google Calendar</span>
        </button>

        <button
          onClick={handleAppleCalendar}
          className="flex items-center justify-center space-x-2 px-4 py-3 bg-secondary text-secondary-foreground rounded-md font-inter text-sm font-medium hover:bg-secondary/90 transition-colors duration-200"
        >
          <Icon name="CalendarIcon" size={18} />
          <span>Apple Calendar</span>
        </button>

        <button
          onClick={handleOutlookCalendar}
          className="flex items-center justify-center space-x-2 px-4 py-3 bg-accent text-accent-foreground rounded-md font-inter text-sm font-medium hover:bg-accent/90 transition-colors duration-200"
        >
          <Icon name="CalendarIcon" size={18} />
          <span>Outlook</span>
        </button>
      </div>
    </div>
  );
};

export default CalendarIntegration;